import { removeAttachmentPreviewsForRow } from 'owa-mail-attachment-previews';
import { lazyRemoveCouponFromStore } from 'owa-mail-coupon-peek';
import { ObservableMap } from 'mobx';
import ConversationItem from 'owa-mail-list-store/lib/store/schema/ConversationItem';
import TableView from 'owa-mail-list-store/lib/store/schema/TableView';
import TableViewConversationRelation from 'owa-mail-list-store/lib/store/schema/TableViewConversationRelation';
import listViewStore from 'owa-mail-list-store/lib/store/Store';
import getTableToRowRelationKey from 'owa-mail-list-store/lib/utils/getTableToRowRelationKey';
import conversationCache from 'owa-mail-store/lib/store/conversationCache';
import ConversationItemParts from 'owa-mail-store/lib/store/schema/ConversationItemParts';
import { MruCache } from 'owa-mru-cache';
import { action, select } from 'satcheljs/lib/legacy';
import { isFeatureEnabled } from 'owa-feature-flags';
import { lazyRemoveMeetingMessagesFromStore } from 'owa-listview-rsvp';

export interface RemoveConversationDataState {
    tableViewConversationRelations: ObservableMap<string, TableViewConversationRelation>;
    tableViews: ObservableMap<string, TableView>;
    conversationItems: ObservableMap<string, ConversationItem>;
    conversationCache: MruCache<ConversationItemParts>;
}

export default select<RemoveConversationDataState>({
    tableViewConversationRelations: () => listViewStore.tableViewConversationRelations,
    tableViews: () => listViewStore.tableViews,
    conversationItems: () => listViewStore.conversationItems,
    conversationCache: () => conversationCache,
})(
    action('removeConversationData')(function removeConversationData(
        rowKey: string,
        tableView: TableView,
        state?: RemoveConversationDataState
    ) {
        const tableConversationRelationKey = getTableToRowRelationKey(rowKey, tableView.id);
        const tableConversationRelations = state.tableViewConversationRelations;
        const conversationId = tableConversationRelations.get(tableConversationRelationKey).id;
        const itemIdsForConversation = tableConversationRelations.get(tableConversationRelationKey)
            .itemIds;

        if (!tableConversationRelations.has(tableConversationRelationKey)) {
            throw new Error('Conversation not found in store');
        }

        // 1. Remove table Conversation relation
        tableConversationRelations.delete(tableConversationRelationKey);

        // 2. Check to see if there are any other table relations for this converation
        let converationFoundInOtherTables = false;
        for (const table of state.tableViews.values()) {
            // We should not refer to the current table
            if (table.id != tableView.id && table.rowIdToRowKeyMap.get(conversationId)) {
                converationFoundInOtherTables = true;
                break;
            }
        }

        // 3. Only remove conversation from listview store when it is not referenced anymore from any table
        if (!converationFoundInOtherTables) {
            state.conversationItems.delete(conversationId);

            // Remove attachment preview well and atttachment view states for this conversation
            removeAttachmentPreviewsForRow(conversationId);

            // Remove coupon data
            if (isFeatureEnabled('tri-coupon-peek')) {
                lazyRemoveCouponFromStore.import().then(removeCouponFromStore => {
                    removeCouponFromStore(conversationId);
                });
            }

            if (isFeatureEnabled('tri-meetingMessageRSVP')) {
                lazyRemoveMeetingMessagesFromStore.importAndExecute(itemIdsForConversation);
            }

            // Remove cached ConversationItemParts from conversationCache if exists
            state.conversationCache.remove(conversationId);
        }
    })
);
